/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-curly-newline */
import React, { useEffect, useState, useMemo } from "react";

import { useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Environments from "../../Environments";
import MOCK_DATA from "../../mock/data";

import BaseFrame from "../../component/wrapper/BaseFrame";
import { HomeLink, InformationLink } from "../../component/breadcrums/Links";
import BackButton from "../../component/button/BackButton";
import SompoLoading from "../../component/loading/SompoLoading";

import NoticeMessageListService, { NoticeMessageListResponse, MsgListItem } from "../../logic/api/NoticeMessageListService";
import NoticeWhatsNewListService, { NoticeWhatsNewListResponse, WhatsNewListItem } from "../../logic/api/NoticeWhatsNewListService";
import { datetime2DateJP } from "../../logic/datetime";
import { getTextFromHTML } from "../../logic/text";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import SompoContext from "../../logic/context/SompoContext";

const TYPE_WHATSNEW = "whatsnew";
const TYPE_MESSAGE = "message";
const MESSAGE_KIND_GET = "0";
interface Information {
    titles: string[];
    datetime?: string;
    messages: string[];
    type: string;
}
interface InformationDetailHandler {
    convertor: (response: any, messageId?: string) => Information;
}

const CONVERTOR_WHATSNEW = (response: any, messageId?: string): Information => {
    const _information: WhatsNewListItem | undefined = (response as WhatsNewListItem[]).find((row) => row.messageId === messageId);
    return {
        titles: _information?.titleList as string[],
        datetime: _information?.startDateStr,
        messages: _information?.messageList as string[],
        type: "Whats' new",
    };
};

const CONVERTOR_MESSAGE = (response: any, messageId?: string): Information => {
    const _information: MsgListItem | undefined = (response as MsgListItem[]).find((row) => row.messageId === messageId);
    return {
        titles: [_information?.title || ""],
        datetime: _information?.startDateStr,
        messages: _information?.messageList as string[],
        type: "メッセージ",
    };
};

const noticeWhatsNewListService = new NoticeWhatsNewListService();
const noticeMessageListService = new NoticeMessageListService();

const InformationDetail = () => {
    const { type, messageId } = useParams();
    const [information, setInformation] = useState<Information | null>(null);
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用

    if (!Environments.MOCK) {
        useEffect(() => {
            sompoContext.setLoading(true); // ローディング開始
            const fetch = async () => {
                let handler: InformationDetailHandler;
                switch (type) {
                    case TYPE_WHATSNEW:
                        handler = {
                            convertor: CONVERTOR_WHATSNEW,
                        };
                        await noticeWhatsNewListService.noticeWhatsNewList(
                            {},
                            (response: NoticeWhatsNewListResponse) => {
                                const newInformation: Information = handler.convertor(response.whatsNewList, messageId);
                                setInformation(newInformation);
                                sompoContext.setLoading(false); // ローディング終了
                            },
                            (error: any) => {
                                console.error(error);
                                showErrorMessage({ message: "What's New情報の取得に失敗しました。", error });
                                setInformation(null);
                                sompoContext.setLoading(false); // ローディング終了
                            }
                        );
                        break;
                    case TYPE_MESSAGE:
                        handler = {
                            convertor: CONVERTOR_MESSAGE,
                        };
                        await noticeMessageListService.noticeMessageList(
                            { kind: MESSAGE_KIND_GET, messageId },
                            (response: NoticeMessageListResponse) => {
                                const newInformation: Information = handler.convertor(response.msgList, messageId);
                                setInformation(newInformation);
                                sompoContext.setLoading(false); // ローディング終了
                            },
                            (error: any) => {
                                console.error(error);
                                showErrorMessage({ message: "メッセージ情報の取得に失敗しました。", error });
                                setInformation(null);
                                sompoContext.setLoading(false); // ローディング終了
                            }
                        );
                        break;
                    default:
                        break;
                }
            };

            // eslint-disable-next-line no-void
            void fetch();
        }, [type, messageId]);
    } else {
        useEffect(() => {
            sompoContext.setLoading(true); // ローディング開始
            switch (type) {
                case TYPE_WHATSNEW:
                    setInformation(CONVERTOR_WHATSNEW(MOCK_DATA.INFORMATION.whatsNewList, messageId));
                    break;
                case TYPE_MESSAGE:
                    setInformation(CONVERTOR_MESSAGE(MOCK_DATA.INFORMATION.msgList, messageId));
                    break;
                default:
                    break;
            }
            sompoContext.setLoading(false); // ローディング終了
        }, []);
    }

    // パンくずリスト表示用タイトル
    const title: string = useMemo(() => (information ? getTextFromHTML(information.titles[0]) : ""), [information]);
    // タイトル表示用dom
    const titleNode = (
        <>
            {information &&
                information.titles.map((info: string) => (
                    <Typography
                        variant="h1"
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            wordBreak: "break-all",
                        }}
                        dangerouslySetInnerHTML={{
                            __html: info,
                        }}
                    />
                ))}
        </>
    );

    return (
        <BaseFrame
            width="70%"
            title={title}
            titleNode={titleNode}
            breadcrumbs={[<HomeLink />, <InformationLink />]}
            content={
                <>
                    {information && !sompoContext.loading ? (
                        <Grid container direction="column">
                            <Grid item>
                                <Typography>{datetime2DateJP(String(information.datetime))}</Typography>
                            </Grid>
                            <Grid item sx={{ width: "100%", pt: 2, pb: 2 }}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        padding: 3,
                                        height: "auto",
                                        overflow: "auto",
                                        borderRadius: "8px",
                                        bgcolor: "background.paper",
                                    }}
                                >
                                    {information.messages.map((info: string) => (
                                        <Typography
                                            sx={{ wordBreak: "break-all" }}
                                            dangerouslySetInnerHTML={{
                                                __html: info,
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                }}
                            >
                                <BackButton navigateTo="/information" label="一覧へ" />
                            </Grid>
                        </Grid>
                    ) : (
                        // fetchが終わるまでローディングアイコンを表示
                        <SompoLoading />
                    )}
                </>
            }
        />
    );
};

export default InformationDetail;
